export default async function doFetch(url) {
    return fetch(url, {cache: "default"});
}

